module.exports = __webpack_public_path__ + "img/sb6.8a522a6a.png";